import { memo } from 'react';
import styled from '@emotion/styled/macro';

import CustomItemIcon from '../utils/CustomItemIcon';
import CustomNavLink from '../utils/CustomNavLink';

const ItemLinkWrapper = ({ itemId, isMaster, icon, label, onClick }) => {
    return (
        <ItemNavLink to={itemId} onClick={onClick}>
            <CustomItemIcon isMaster={isMaster} icon={icon} smallIcon={true} />
            <p>{label}</p>
        </ItemNavLink>
    );
};

const ItemNavLink = styled(CustomNavLink)`
    display: flex;
    align-items: center;
    padding: 6px 10px;
    flex-grow: 1;
    overflow: hidden;
    border-radius: 6px;

    &:focus {
        outline: none;
    }

    > p {
        margin-left: var(--chakra-space-2);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--chakra-colors-text-secondary);
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
    }

    &.active {
        background-color: var(--chakra-colors-blue-50);
        > p {
            color: var(--chakra-colors-black);
        }
    }
`;

export default memo(ItemLinkWrapper);
